import { AppAreaConfig } from '@/funnels/@types'

const appAreaConfig: AppAreaConfig = {
	appArea: 'male-japanese-diet',
	landing: {
		ids: ['loader-japanese-diet'],
		route: {
			path: '/japanese-diet-m',
			name: 'male-japanese-diet-funnel',
		},
	},
	funnel: {
		id: 'ob-male-japanese-diet',
		route: {
			path: '/japanese-diet-m/ob/:page(.*)?',
			name: 'male-japanese-diet',
		},
		slug: 'male-japanese-diet',
		theme: 'light',
		locale: ['en'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-japanese-diet-m',
	},
	upsell: {
		routeNames: ['upsell-static-subscription-activated', 'upsell-m'],
	},
	upgrade: {
		routeName: null,
	},
}

export default appAreaConfig
